import { useState, useEffect } from 'react'

interface DeviceDetect {
  isMobile: boolean | null
  isDesktop: boolean | null
  isAndroid: boolean | null
  isIos: boolean | null
}

const useDeviceDetect = (): DeviceDetect => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null)
  const [isDesktop, setIsDesktop] = useState<boolean | null>(null)
  const [isAndroid, setIsAndroid] = useState<boolean | null>(null)
  const [isIos, setIsIos] = useState<boolean | null>(null)

  useEffect(() => {
    const detectDeviceType = () => {
      const isMobileAgent = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
        navigator.userAgent
      )
      const isAndroidAgent = /Android/i.test(navigator.userAgent)
      const isIosAgent = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      const isDesktopAgent = !isMobileAgent

      setIsMobile(isMobileAgent)
      setIsDesktop(isDesktopAgent)
      setIsAndroid(isAndroidAgent)
      setIsIos(isIosAgent)
    }

    detectDeviceType()

    // Listen for window resize events to update the device type
    const handleResize = () => {
      detectDeviceType()
    }

    window.addEventListener('resize', handleResize)

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return {
    isMobile,
    isDesktop,
    isAndroid,
    isIos,
  }
}

export default useDeviceDetect
